// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 355) return "static/chunks/355-73e6a3091662cd30.js";
	if (chunkId === 871) return "static/chunks/871-3174dac22f583231.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 511 ? "35fc8c20" : chunkId) + "." + {"511":"aded1e4ee811fe4a","579":"1d4da96574142b39","973":"087e67f23d9a3a22"}[chunkId] + ".js";
};